<template>
  <div class="container container-l flex-middle flex-center flex-column">
    <p id="intro" class="width-700 margin-2xl-bottom">
      {{ t("justopp.userCompanyProfile.introText") }}
    </p>
    <div class="profile-form">
      <crud-edit
        item-src="user/current"
        :form-source="`entity/user/${userProfile.id}/update`"
        :submit-url="'user/' + userProfile.id"
        :form-config="formConfig"
        item-mapper="raw" />
    </div>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import CrudEdit from "@/client/components/crud/customV1/Edit.vue";
import formConfig from "./formConfig";
import { mapState } from "vuex";

export default {
  components: {
    CrudEdit,
  },
  layout: {
    component: "UserDashboardInner",
    params: {
      title: "justopp.companyProfile.pageTitle",
      subTitle: "justopp.companyProfile.pageSubtitle",
      backButton: true,
    },
  },
  middleware: {
    requireUser: {},
    requireNotVendor: {},
  },
  setup() {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();

    return { asyncOps, asyncOpsReady, asyncStatus, formConfig };
  },
  meta: "justopp.userProfile.browserTitle",
  data() {
    return {};
  },
  computed: {
    ...mapState(["user"]),
    userProfile() {
      return this.user.user.profile;
    },
  },
  watch: {},
  methods: {},
};
</script>

<style lang="scss">
.profile-form {
  .form {
    .fields {
      display: grid;
      grid-template-columns: 48% 48%;
      column-gap: var(--margin-max);
    }

    .company-details {
      order: -1;
      grid-column: 1 / span 2;
    }

    .last {
      order: 1;
    }
  }
}
</style>

<style lang="scss" scoped>
p#intro {
  align-self: flex-start;
}
</style>
